import { IWatercraftType } from "@/store/modules/watercraftType/types";
import { baseWatercraftType } from "./defaultObjects";
import { cloneDeep, defaultsDeep } from "lodash";

export function watercraftTypeDefault(
  watercraftType: Partial<IWatercraftType>
): IWatercraftType {
  return defaultsDeep(
    cloneDeep(watercraftType),
    Object.assign({}, baseWatercraftType())
  );
}
